import { render, staticRenderFns } from "./LinkTitle.vue?vue&type=template&id=6a967322&"
import script from "./LinkTitle.vue?vue&type=script&lang=ts&"
export * from "./LinkTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports